// extracted by mini-css-extract-plugin
module.exports = {"colorList":"_2GK5w"};